// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"331":"52cdaf86","445":"b078ec21"}[chunkId] + ".chunk.js";
};